import { render } from "./index.vue?vue&type=template&id=2a638695&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2a638695&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=2a638695&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a638695"]])

export default __exports__